import type { ScheduleTaskType } from '@risksmart-app/domain/src/types/consts';
import { getFriendlyId } from '@risksmart-app/domain/src/types/consts';
import type { SchedulableTarget } from '@risksmart-app/drizzle/src/dto';
import { sortByLabel } from 'src/components/form/form-utils';

import type { ScheduleFormFieldData } from './scheduleFormSchema';

export type ScheduleTarget = ScheduleFormFieldData['Targets'][number];

/**
 * The options a multiselect's change event reports as selected, as the richer
 * option objects the form stores rather than the event's bare `{ value }`.
 */
export const pickSelectedOptions = <T extends { value: string }>(
  options: T[],
  selected: readonly { value?: string }[]
): T[] =>
  options.filter((option) =>
    selected.some((choice) => choice.value === option.value)
  );

/**
 * The friendly id as a one-element tag list, which is what puts it on its own
 * row beneath the title. Empty for a type `getFriendlyId` has no prefix for.
 */
const targetOptionTags = (target: SchedulableTarget): string[] => {
  const friendlyId = getFriendlyId(target.ObjectType, target.SequentialId);

  return friendlyId === '' ? [] : [friendlyId];
};

export const toTargetOptions = (
  targets: SchedulableTarget[],
  taskType: ScheduleTaskType,
  objectType: SchedulableTarget['ObjectType']
): ScheduleTarget[] =>
  targets
    .filter((target) => target.ObjectType === objectType)
    .map((target) => ({
      value: target.TargetId,
      label: target.Title,
      tags: targetOptionTags(target),
      Type: taskType,
    }))
    .sort(sortByLabel);
